import {DateTime} from "luxon";

export const createBookingData = (
    formData,
    serviceId,
    employeeId,
    branchId,
    currentDateISO,
    companyReCall
) => {

    const dt = DateTime.fromISO(currentDateISO, { setZone: true });


    const formattedDate = dt.toFormat('yyyy-MM-dd');
    const timeString = dt.toFormat('HH:mm:ss');



    const nowSameZone = DateTime.now().setZone(dt.zoneName);
    let notificationDT = null;


    switch (formData.notification) {
        case '1': {
            const candidate = dt.minus({ minutes: 30 });
            if (candidate > nowSameZone) notificationDT = candidate;
            break;
        }
        case '2': {
            notificationDT = dt.minus({ hours: 1 });
            break;
        }
        case '3': {
            notificationDT = dt.minus({ hours: 2 });
            break;
        }
        case '4': {
            notificationDT = dt.minus({ hours: 3 });
            break;
        }
        case '5': {
            notificationDT = dt.minus({ days: 1 });
            break;
        }
        case '6': {
            notificationDT = dt.minus({ days: 3 });
            break;
        }
        default: {
            notificationDT = null;
        }
    }


    const notificationTime =
        formData.isNeedNotification && notificationDT
            ? notificationDT.toFormat('yyyy-MM-dd HH:mm:ss')
            : null;


    return {
        date: formattedDate,
        time: timeString,
        notificationTime,
        service: serviceId,
        employee: employeeId,
        branch: parseInt(branchId, 10),
        notes: formData.userComment || null,
        isNeedClientRecall: companyReCall ?? formData.isNeedClientRecall ?? false,
        client: {
            name: formData.userName,
            surname: formData.userSurname || null,
            patronymic: formData.patronymic || null,
            phone: formData.userPhone,
            email: formData.userEmail || null,
        },
    };
};